import { useState, useEffect, useCallback } from 'react';

/**
 * Хук позволяет скрывать элементы в зависимости от скролла
 * @export
 * @param {number} offset - количество пикселей, после которого элемент скрывается
 * @param {boolean} initiallyVisible - начальная видимость элемента
 */
export function useHiddenBellowOffset(offset: number, initiallyVisible?: boolean) {
  const [visible, setVisible] = useState(Boolean(initiallyVisible));

  const handler = useCallback(() => {
    if (window.pageYOffset >= offset) {
      setVisible(false);
    } else {
      setVisible(true);
    }
  }, [offset]);

  useEffect(() => {
    window.addEventListener('scroll', handler);

    return () => {
      window.removeEventListener('scroll', handler);
    };
  }, [handler]);

  return visible;
}
